import { Grid, TextField } from '@material-ui/core'
import Dropdown from 'components/Dropdown'
import PostCodeAddress from 'components/PostCodeAddress/PostCodeAddress'
import { Customize, PostCodeDetail } from 'graphql/types'
import { useEffect } from 'react'
import { ViewType } from 'store/GeneralState/GeneralState.reducer'

import { useTranslation } from 'react-i18next'
import {
    PortabilityAddress,
    PortabilityAddressHolder,
    PortabilityViewFields,
} from 'store/PortabilityState/PortabilityState.reducer'
import RenderRadios from './RenderRadios'

export interface RenderAddressProps {
    address: PortabilityAddress
    addressHolder: PortabilityAddressHolder
    onChange: (field: PortabilityViewFields, label: string, index: number, value: string) => void
    handleAddressHolderChange: (data: Partial<PortabilityAddressHolder>) => void
    selected: boolean
    customizeJsData: Customize | undefined
    handleAddressSelected: (data: PostCodeDetail) => void
}
const RenderAddress = (props: RenderAddressProps): JSX.Element => {
    const {
        address,
        addressHolder,
        onChange,
        selected,
        handleAddressSelected,
        customizeJsData,
        handleAddressHolderChange,
    } = props
    const field = PortabilityViewFields.ADDRESS
    const { t } = useTranslation()

    useEffect(() => {
        if (selected) {
            handleAddressSelected({
                address: {
                    street: '',
                    postcode: '',
                    buildingNumber: -1,
                    locality: '',
                    building: '',
                    country: '',
                    buildingNumberAddition: '',
                },
                mailLines: [],
                location: {
                    latitude: 0,
                    longitude: 0,
                    precision: '',
                },
                language: '',
                country: {
                    name: '',
                    iso3Code: '',
                },
                details: {
                    deuStreet: {
                        districtName: '',
                    },
                },
            })
        }
    }, [selected])

    return (
        <>
            <Grid container spacing={1} style={{ marginBottom: '15px', marginTop: '45px', flexDirection: 'column' }}>
                <RenderRadios field={field} customizeJsData={customizeJsData} onChange={onChange} selected={selected} />
                {!selected && (
                    <>
                        {customizeJsData?.portabilityConfiguration.previousContractAddressHolder && (
                            <Grid container item spacing={1}>
                                <Grid item xs={12} md={6}>
                                    <Dropdown
                                        testIdentifier={{
                                            input: 'SALUTATION',
                                            viewType: ViewType.CONTACT_DATA,
                                            category: 'PERSONAL',
                                        }}
                                        label={t('contactDataStrings.salutation')}
                                        options={
                                            customizeJsData?.contactDataViewConfiguration.salutationOptionsPersonal
                                        }
                                        value={addressHolder.salutation}
                                        onChange={(e): void => {
                                            handleAddressHolderChange({
                                                salutation: e.target.value as string,
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth={true}
                                        label={t('contactDataStrings.title')}
                                        variant={'outlined'}
                                        value={addressHolder.title}
                                        onChange={(e): void => {
                                            handleAddressHolderChange({
                                                title: e.target.value as string,
                                            })
                                        }}
                                        inputProps={{ maxLength: 30 }}
                                    />
                                </Grid>
                                {addressHolder.salutation === 'Firma' && (
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth={true}
                                            label={t('contactDataStrings.companyName') + ' *'}
                                            variant={'outlined'}
                                            value={addressHolder.company}
                                            onChange={(e): void => {
                                                handleAddressHolderChange({
                                                    company: e.target.value as string,
                                                })
                                            }}
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </Grid>
                                )}
                                {addressHolder.salutation === 'Firma' &&
                                    customizeJsData?.contactDataViewConfiguration.enableAlternativeLegalForm && (
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth={true}
                                                label={t('contactDataStrings.companyLegalForm') + ' *'}
                                                variant={'outlined'}
                                                value={addressHolder.companyLegalForm}
                                                onChange={(e): void => {
                                                    handleAddressHolderChange({
                                                        companyLegalForm: e.target.value as string,
                                                    })
                                                }}
                                                inputProps={{ maxLength: 50 }}
                                            />
                                        </Grid>
                                    )}

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth={true}
                                        label={t('contactDataStrings.name')}
                                        variant={'outlined'}
                                        value={addressHolder.name}
                                        placeholder={'Max'}
                                        onChange={(e): void => {
                                            handleAddressHolderChange({
                                                name: e.target.value as string,
                                            })
                                        }}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth={true}
                                        label={t('contactDataStrings.lastName')}
                                        variant={'outlined'}
                                        value={addressHolder.lastName}
                                        placeholder={'Mustermann'}
                                        onChange={(e): void => {
                                            handleAddressHolderChange({
                                                lastName: e.target.value as string,
                                            })
                                        }}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </Grid>
                            </Grid>
                        )}

                        <PostCodeAddress
                            data={{
                                street: address.street,
                                houseNumber: address.houseNumber,
                                addition: address.addition,
                                city: address.city,
                                zipcode: address.zip,
                                district: address.district,
                            }}
                            handleAddressSelect={handleAddressSelected}
                        />
                    </>
                )}
            </Grid>
        </>
    )
}

export default RenderAddress
